module.exports = __webpack_public_path__ + "static/media/PlatformDifferences_English.03b36c85.png";